import { Position } from "@xyflow/react";
import { NODE_REGISTRY } from "components/CC/Nodes/node-config";
import { BaseNodeProps } from "components/CC/Nodes/node-types";
import { BaseNode } from "components/CC/Nodes/NodeBase/BaseNode";
import { MirrorIcon, MirrorNumberBadge } from "components/CC/Nodes/NodeIcons";
import { NodeType } from "components/CC/types/enums";
import { TransparentHandle } from "components/CC/UI/TransparentHandle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

interface MirrorNodeData {
    formData?: { mirrorElement?: string };
    mirroredNodeSortOrder?: number;
}

export const MirrorNode = ({ id, data }: BaseNodeProps) => {
    const { t } = usePaldockTranslation("components.connection-creator");
    const nodeData = data as MirrorNodeData;
    const mirroredSortOrder = nodeData?.mirroredNodeSortOrder;

    const badge = mirroredSortOrder !== undefined ? <MirrorNumberBadge number={mirroredSortOrder} /> : undefined;

    return (
        <div>
            <BaseNode
                id={id}
                data={data}
                color={NODE_REGISTRY[NodeType.Mirror].color}
                label={t("nodes.mirror.title")}
                badge={badge}
            >
                <MirrorIcon />
            </BaseNode>
            <TransparentHandle position={Position.Left} type="target" />
            <TransparentHandle position={Position.Right} type="source" />
        </div>
    );
};
